<template>
  <fts-client-modal
    title="Create New Workspace"
    @closed="reset"
    ref="ftsClientModal"
  >
    <!-- header:icon -->
    <font-awesome-icon slot="icon" :icon="['far', 'plus-square']" fixed-width />
    <!-- body -->
    <template #body>
      <fts-form-element
        :form-data="formData"
        :item="{ 
          'displayName': 'Workspace Name', 
          'fieldName': 'name',
          'type': 0,
          'required': true,
        }"
        :validator="$v.formData"
        comfort-design
        ref="workspaceName"
        @keyup:enter="done"
      >
        <!-- workspace name format error -->
        <div
          slot="errorMessage"
          v-if="
            $v.formData.name &&
            $v.formData.name.format === false
          "
        >
          <div class="fts-text-default">Allow alphabet and numeric only.</div>
          <div class="fts-text-default">
            Allow special characters
            <span
              v-for="(x, ind) in workspaceNameSpecialCharacters"
              :key="`wnsc-${ind}`"
              class="fts-font-bold"
            >
              {{x}}
            </span>
          </div>
          <div>Workspace name cannot contain invalid characters.</div>
        </div>
      </fts-form-element>
    </template>
    <!-- footer:right -->
    <template #footerRight>
      <fts-btn text :disabled="loading" @click="close">
        <font-awesome-icon :icon="['fas', 'times']" />Close
      </fts-btn>
      <fts-btn color="primary" :loading="loading" @click="done">
        <font-awesome-icon :icon="['fas', 'check']" />Create
      </fts-btn>
    </template>
  </fts-client-modal>
</template>

<script>
import Vue from "vue";
import Vuelidate from "vuelidate";
Vue.use(Vuelidate);
import { required } from "vuelidate/lib/validators";

import designValidator from "../commons/designValidator";

import FTSClientModal from "../elements/FTSClientModal";
import FTSBtn from "../elements/FTSBtn";
import FTSFormElement from "../elements/FTSFormElement";

export default {
  components: {
    "fts-client-modal": FTSClientModal,
    "fts-btn": FTSBtn,
    "fts-form-element": FTSFormElement,
  },
  data: () => ({
    formData: {},
    resolve: null,
    loading: false,
  }),
  validations() {
    let formData = {}
    formData = {
      name: { 
        required,
        format: designValidator.workspaceNameFormat, 
      }
    }
    return { formData }
  },
  methods: {
    async show() {
      return new Promise(resolve => {
        this.resolve = resolve;
        this.$refs.ftsClientModal.show();
        this.$nextTick(() => {
          try {
            this.$refs.workspaceName.$el.getElementsByTagName('input')[0].focus();
          } catch(err) {
            console.warn("[DOMException]", err);
          }
        });
      });
    },
    async done() {
      this.$v.formData.$touch();
      if (this.$v.formData.$invalid) {
        this.$toasted.global.invalidFormValidate();
      } else {
        this.loading = true;  
        try {
          const res = await this.$store.dispatch('createWorkspace', this.formData);
          this.resolve && this.resolve(res.data.id);
          this.close();
        } catch(err) {
          this.$toasted.global.error({ response: err.response });
        } finally {
          this.loading = false;
        }
      }
    },
    close() {
      this.$refs.ftsClientModal.close();
    },
    reset() {
      this.$v.$reset();
      Object.assign(this.$data, this.$options.data.apply(this));
    },
  },
  computed: {
    workspaceNameSpecialCharacters() {
      return designValidator.workspaceNameSpecialCharacters.split("");
    },
  },
}
</script>